import { render, staticRenderFns } from "./LevelBar.htm?vue&type=template&id=21f84dec&scoped=true&"
import script from "./LevelBar.ts?vue&type=script&lang=js&"
export * from "./LevelBar.ts?vue&type=script&lang=js&"
import style0 from "./LevelBar.scss?vue&type=style&index=0&id=21f84dec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f84dec",
  null
  
)

export default component.exports